import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Homesec = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);
    const navigate = useNavigate();
    const langContent = {
        English: {
            heading: "Directorate of Archaeology and Museums",
            description: `The subject of ‘Archaeology’ is included in the concurrent list of the Constitution of India. It comes under the jurisdiction of both the Centre and the State administration. With the formation of the independent State of Maharashtra; the Department of Archives and Historical Monuments was established for the first time in the year 1960. In the year 1977; for administrative convenience, two separate directorates viz., the Directorate of Archaeology and Museums, and the Directorate of Archives were created.`,
            learnMore: "Learn More →",
            schemes: "Schemes",
            awards: "Awards",
            schemesText: "Forts and Monuments being a living testimony to our glorious heritage need to be conserved and preserved. Forts in Maharashtra are evidences of the brilliance of Chhatrapati Shivaji Maharaj as a King and an administrator.",
            awardstext: "Padmashri Sadashiv Gorakshakar’s contribution to heritage preservation and museum movement is invaluable.",
        },
        मराठी: {
            heading: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय",
            description: `'पुरातत्त्व' हा विषय भारतीय संविधानाच्या समवर्ती सूचीमध्ये समाविष्ट आहे. तो केंद्र आणि राज्य प्रशासनाच्या अधिकारक्षेत्रात येतो. स्वतंत्र महाराष्ट्र राज्याच्या निर्मितीसह, १९६० मध्ये प्रथमच अभिलेखागार आणि ऐतिहासिक स्मारके विभागाची स्थापना करण्यात आली. प्रशासकीय सोयीसाठी १९७७ मध्ये, पुरातत्त्व आणि संग्रहालये संचालनालय आणि अभिलेखागार संचालनालय अशी दोन स्वतंत्र संचालनालये निर्माण करण्यात आली.`,
            learnMore: "अधिक वाचा →",
            schemes: "योजना",
            awards: "पुरस्कार",
            awardstext: "वारसा जतन, संग्रहालय चळवळ व उभारणी या विषयांतील पद्मश्री सदाशिव गोरक्षकर यांचे योगदान मोलाचे आहे.",
            schemesText: "गड किल्ल्यांचे संवर्धन चांगल्या प्रकारे व्हावे व त्यासाठी दुर्गप्रेमी संस्थांचा, व्यक्तींचा आणि दुर्ग तंज्ञाचा सहभाग मिळावा तसेच छत्रपती शिवाजी महाराजांच्या प्रेरणादायी जीवनाची नवीन पिढीला ओळख करुन देण्यासाठी",
        }
    };
    const text = langContent[selectedLang];
    // const isMarathi = selectedLang === "मराठी";
    const handleNavigate = (path) => {
        navigate(path);
    };

    const words = text.heading.trim().split(/\s+/);

    return (
        <div className="relative h-full pb-6 bg-slate-200 overflow-hidden -mt-6 rounded-lg px-2 sm:px-4 lg:px-4">
            {/* Heading */}
            <h2 className="font-canto text-center text-xl sm:text-2xl md:text-3xl lg:text-[40px] py-8 lg:mt-0  px-2 sm:px-4 lg:px-4">
                {/* Small & Medium screens → normal heading */}
                <span className="block lg:hidden">
                    {text.heading}
                </span>

                {/* Large screens only → 2-1-2 */}
                {/* <span className="hidden lg:block leading-none"> */}
                <span
                    className={`hidden lg:block ${selectedLang === "मराठी" ? "leading-tight lg:text-[40px]" : "leading-none"
                        }`}
                >
                    <span className="block ">
                        {words.slice(0, 2).join(" ")}
                    </span>
                    <span className="block ">
                        {words.slice(2, 3).join(" ")}
                    </span>
                    <span className="block">
                        {words.slice(3, 5).join(" ")}
                    </span>
                </span>
            </h2>

            {/* Scroll Background Text Section */}
            <div className="relative flex justify-center  no-dark-bg -mt-10 -sm:mt-4">
                {/* Text on Image */}
                <div className=" flex flex-col items-center justify-center text-center px-3 sm:px-6 md:px-10 lg:px-10 py-4">
                    <p className="font-futura text-[#2c1b07] mt-2 text-[12px] sm:text-[12px] md:text-[14px] lg:text-[17px] lg:leading-[26px] max-w-[16rem] sm:max-w-[20rem] md:max-w-[34rem] lg:max-w-[48rem]">
                        {text.description} </p>

                    {/* Button */}
                    <button onClick={() => handleNavigate("/overview")}
                        className="mt-3 sm:mt-5 
                                   px-3 sm:px-5 
                                   py-1 sm:py-2 
                                   text-[8px] sm:text-[11px] md:text-sm 
                                   bg-transparent border border-[#2c1b07] text-[#2c1b07] 
                                   rounded-full mb-4
                                   hover:bg-orange-500 hover:text-white 
                                   hover:border-transparent transition"
                    >
                        {text.learnMore}
                    </button>
                </div>
            </div>

            {/* Schemes Section */}
            {/* <div className="px-4 sm:px-6 md:px-12 lg:px-20 pb-16 space-y-12 mt-16 py-8">


                <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12">
                    <img
                        src={schemeImg}
                        alt="Schemes"
                        className="w-full md:w-1/2 rounded-lg max-h-[200px]"
                    />
                    <div className="text-center md:text-center md:w-1/2">
                        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold mb-5">
                            {text.schemes}</h2>
                        <p className="text-[14px] text-gray-800 sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
                            {text.schemesText}
                        </p>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row-reverse items-center gap-6 md:gap-12">
                    <img
                        src={awardsImg2}
                        alt="Vision"
                        className="w-full md:w-1/2 rounded-lg max-h-[200px]"
                    />
                    <div className="text-center md:text-center md:w-1/2">
                        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold mb-5">{text.awards}</h2>
                        <p className="text-[14px] text-gray-800 sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
                            {text.awardstext}                        </p>
                    </div>
                </div>
            </div> */}

        </div>
    );
};

export default Homesec;
